module.exports = __webpack_public_path__ + "dcc2b7395bb547993974a4b16d0911de.png";